import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigation } from "react-router-dom";
import { selectUser } from "../../redux/features/userSlice";
import Sidebar from "./components/Sidebar";
import "./Dashboard.css";
import Registration from "./registration/Registration";

export default function Dashboard({ Component }) {
  const user = useSelector(selectUser);

  const [isOverview, setIsOverview] = useState(false);
  const [isTherapists, setIsTherapists] = useState(true);
  const [isClients, setIsClients] = useState(false);
  const [isProfile, setIsProfile] = useState(false);

  const onSwitchSections = (stateFunc) => {
    setIsOverview(false);
    setIsTherapists(false);
    setIsClients(false);
    setIsProfile(false);
    stateFunc(true);
  };

  useEffect(() => {
    if (window.location.pathname === "/overview") {
      onSwitchSections(setIsOverview);
    } else if (window.location.pathname === "/therapists") {
      onSwitchSections(setIsTherapists);
    } else if (window.location.pathname === "/clients") {
      onSwitchSections(setIsClients);
    } else if (
      window.location.pathname === window.location.pathname?.split("/")[1]
    ) {
      onSwitchSections(setIsProfile);
    }
  }, [window.location.pathname]);

  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 732) {
      setIsMobileView(true);
    } else {
      setIsMobileView(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 732) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    });
  }, []);
  return (
    <div className="dashboard">
      <div className="content">
        <Sidebar
          isOverview={isOverview}
          isTherapists={isTherapists}
          isClients={isClients}
          isMobileView={isMobileView}
          isProfile={isProfile}
        />

        <div className={`container ${isMobileView && "mobile"}`}>
          {user ? <Component /> : <Registration />}
        </div>
      </div>
    </div>
  );
}
